class FrontpageVideo {
  constructor() {
    this.video = document.querySelector('.ns-frontpage-video');
    this.vid = document.querySelector('.ns-frontpage-video__video video');
    this.thumb = document.querySelector('.ns-frontpage-video__thumbnail');

    if(!!this.video){
      this.muteButton = document.querySelector('.ns-frontpage-video__sound');
      this.playButton = document.querySelector('.ns-frontpage-video__play');
    
      if(window.screen.width < 992){
        this.vid.pause();
        this.playButton.classList.add('active');
      }

      if(!!this.muteButton){
        this.muteButton.addEventListener('click', () => {
          if(this.muteButton.classList.contains('active')){
            this.muteButton.classList.remove('active')
            this.vid.muted = false;
          } else{
            this.muteButton.classList.add('active');
            this.vid.muted = true;
          }
          this.toggleAriaPressed(this.muteButton);
        })
      }

      if(!!this.playButton){
        this.playButton.addEventListener('click', () => {
          if(this.playButton.classList.contains('active')){
            this.playButton.classList.remove('active');
            if(this.thumb){
              this.thumb.style.zIndex = '5';
            }
            this.vid.play();
          } else{
            this.playButton.classList.add('active');
            if(window.screen.width < 992){
              if(this.thumb){
                this.thumb.style.zIndex = '15';
              }
            }
            this.vid.pause();
          }
          this.toggleAriaPressed(this.playButton);
        })
      }
    }

  }

  toggleAriaPressed(button){
    let aria = button.getAttribute('aria-pressed');
    
    if(aria=="false"){
      aria = "true";
    } else{
      aria = "false";
    }
    button.ariaPressed = aria;
  }

}

export default FrontpageVideo;
